import { MemberService } from "components/member-service/MemberService";
import CardTemplate from "components/card/card-template/CardTemplate";
import { HoursOperation } from "components/hours-operation/HoursOperation";
import { useIsMobile } from "hooks";
import React from "react";
import CallToActionButton from "components/form-fields/call-to-action-button/CallToActionButton";
import { useQuote } from "hooks/useQuote";
import { useOffer } from "hooks/useOffer";

interface NeedsCloserLookProps {
    navigateTo?: string;
}

const NeedsCloserLook = ({ navigateTo = "-quote" }: NeedsCloserLookProps) => {
    // ========== Hooks ==========
    const isMobile = useIsMobile();
    const { quoteData } = useQuote();
    const { offerData } = useOffer();

    // ========== State ==========

    // ========== Computed Values ==========
    const title = isMobile ? "Your Application Needs a Closer Look" : "This Application Needs a Closer Look";
    const applicantType = quoteData?.applicantType ?? "member";
    const memberOfferAvailable = offerData?.memberOfferAvailable ?? true;
    const spouseOfferAvailable = offerData?.spouseOfferAvailable ?? true;

    // ========== Render ==========
    return (
        <CardTemplate title={title} className="text-base-content">
            <div className="font-medium text-base-content text-base flex flex-col gap-5">
                <p className="leading-6 text-base text-base-content font-medium" id={`needs-closer-look-to-${applicantType}`}>
                    {applicantType === "spouse"
                        ? "We're sorry, but your spouse's application requires further review, and we can't finish processing it at this time. You do not have full life insurance coverage yet, but we have securely stored your information for review. AAA Life will send an email to the address you provided once a decision is made."
                        : "We're sorry, but your application requires further review, and we can't finish processing it at this time. You do not yet have full life insurance coverage, but we have securely stored your information and note it for review. AAA Life will send an email to the address your provided once a decision is made."}
                </p>

                <p className="leading-5 text-sm text-base-content font-medium pr-4">
                    If you have further questions or wish to learn about our other life insurance options that may be available,
                    please contact our Member Service Advocates.
                </p>

                <MemberService titleClassName="text-black/90" />

                <HoursOperation className="text-black/90" />

                <CallToActionButton
                    applicantType={applicantType}
                    memberOfferAvailable={memberOfferAvailable}
                    spouseOfferAvailable={spouseOfferAvailable}
                    navigateTo={navigateTo}
                />
            </div>
        </CardTemplate>
    );
};

export default NeedsCloserLook;
